// hooks
import useAuth from '../hooks/useAuth';
import Forbidden from '../components/Forbidden';

// ----------------------------------------------------------------------

type RoleBasedGuardProp = {
    hasContent?: boolean;
    roles?: string[];
    children: React.ReactNode;
};

export default function RoleBasedGuard({ hasContent, roles, children }: RoleBasedGuardProp) {
    const { userRole } = useAuth();

    if (typeof roles !== 'undefined' && !roles.includes(userRole)) {
        return hasContent ? <Forbidden /> : null;
    }

    return <>{children}</>;
}
